// 引入axios
import axios from "axios";
import $router from "@/router";
// 创建axios实例

const Service = axios.create({
  // 请求的跟路径
  // baseURL: "http://192.168.18.167:81",//内网-小曹
  // baseURL: "http://192.168.18.55:81",//内网-武京
  // baseURL: "http://192.168.18.252:8081",//服务器
  baseURL: "https://server.sanchangsys.com",//外网
  // 定义统一的请求头
  headers: {
    "content-Type": "application/x-www-form-urlencoded",
    'Authorization': "",
  },
  // 配置请求超时时间
  timeout: 60000,
});

Service.interceptors.request.use(config => {
  if (localStorage.getItem('token')) {
    //在请求头加入token，名字要和后端接收请求头的token名字一样 
    config.headers.Authorization = localStorage.getItem('token') ? 'Bearer ' + localStorage.getItem('token') : '';
  }
  return config
},
  (err) => {
    err.message = '服务器异常，请联系管理员！'
    // 错误抛到业务代码
    return Promise.reject(err)
  }
)

// 响应拦截器
Service.interceptors.response.use(
  response => {
    const status = response.status

    // 特殊状态码处理
    if (response.data.code == -2) {
      $router.push({ path: "/" });
      console.log('重新登录');
    }

    let msg = ''

    if (status < 200 || status >= 300 && status != 401 && status != 500) {
      // 处理http错误，抛到业务代码
      msg = showStatus(status)
      if (typeof response.data === 'string') {
        response.data = { msg }
      } else {
        response.data.msg = msg
      }
      return response
    } else if (status == 200) {
      return response
    } else if (status == 500) {
      msg = showStatus(status)
      response.data = { msg: msg }
      return response
    }

  },
  (err) => {
    err.message = '请求超时或服务器异常，请检查网络或联系管理员！'
    return Promise.reject(err)
  }
)
export default Service;